import { Color3 } from "@babylonjs/core/Maths/math.color.js";
import { ShaderMaterial } from "@babylonjs/core/Materials/shaderMaterial.js";
export class TransparentUnlitMaterial extends ShaderMaterial {
    constructor(name, scene) {
        super(name, scene, {
            vertexSource: `precision highp float;
                    attribute vec3 position;
                    uniform mat4 worldViewProjection;
                    void main(void) {
                        gl_Position = worldViewProjection * vec4(position, 1.0);
                    }`,
            fragmentSource: `precision highp float;
                    uniform float alpha;
                    uniform vec3 color3;
                    
                    void main(void) {
                        gl_FragColor = vec4(color3.r, color3.g, color3.b, alpha);
                    }`,
        }, {
            attributes: ["position"],
            uniforms: ["worldViewProjection", "color3", "alpha"],
            needAlphaBlending: true,
        });
        this._color3 = Color3.Black();
        this.color3 = Color3.Black();
        this.alpha = 1;
        this.backFaceCulling = false;
    }
    get alpha() { return this._alpha; }
    set alpha(value) {
        this._alpha = value;
        this.setFloat("alpha", value);
    }
    get color3() { return this._color3; }
    set color3(value) {
        this._color3 = value.clone();
        this.setColor3("color3", this._color3);
    }
}
